var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavSignatures({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33302 13.4139C7.33302 13.0457 7.6315 12.7472 7.99969 12.7472H13.9997C14.3679 12.7472 14.6664 13.0457 14.6664 13.4139C14.6664 13.7821 14.3679 14.0806 13.9997 14.0806H7.99969C7.6315 14.0806 7.33302 13.7821 7.33302 13.4139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 2.66634C11.8014 2.66634 11.6113 2.7451 11.4711 2.88529L3.26833 11.0881L2.91593 12.4976L4.32552 12.1452L12.5283 3.94248C12.5977 3.87307 12.6528 3.79066 12.6903 3.69996C12.7279 3.60927 12.7472 3.51206 12.7472 3.41389C12.7472 3.31572 12.7279 3.21851 12.6903 3.12781C12.6528 3.03712 12.5977 2.95471 12.5283 2.88529C12.4589 2.81588 12.3765 2.76081 12.2858 2.72324C12.1951 2.68568 12.0979 2.66634 11.9997 2.66634ZM10.5283 1.94248C10.9185 1.55224 11.4478 1.33301 11.9997 1.33301C12.273 1.33301 12.5435 1.38683 12.796 1.49141C13.0485 1.59598 13.2779 1.74926 13.4711 1.94248C13.6643 2.13571 13.8176 2.36511 13.9222 2.61757C14.0267 2.87003 14.0806 3.14062 14.0806 3.41389C14.0806 3.68715 14.0267 3.95774 13.9222 4.21021C13.8176 4.46267 13.6643 4.69207 13.4711 4.88529L5.13776 13.2186C5.05232 13.3041 4.94527 13.3647 4.82805 13.394L2.16138 14.0607C1.9342 14.1174 1.69387 14.0509 1.52828 13.8853C1.3627 13.7197 1.29613 13.4794 1.35293 13.2522L2.01959 10.5855C2.0489 10.4683 2.10951 10.3613 2.19495 10.2758L10.5283 1.94248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSignatures);
export default __webpack_public_path__ + "static/media/nav-signatures.019408f75c3ea63522b47d044b956c07.svg";
export { ForwardRef as ReactComponent };